import React, { Component } from 'react';
import FormField from "../Components/FormField"

import { ErrorMessages } from "../utils/validators"

import './Signup.css';
import swal from 'sweetalert';
import {vendorTypes, countries, nigeriaPriceRanges, usPriceRanges} from '../constants'
let allTypes = vendorTypes

let api = "https://vendor.lushplans.com/"
export default class Signup extends Component {
  constructor(props) {
    super(props)
    
    
    this.nigeriaPriceRanges = nigeriaPriceRanges.map((item, index) => {
      return { label : item, value : item }
    })

    this.usPriceRanges = usPriceRanges.map((item, index) => {
      return { label : item, value : item }
    })    

    let countryList = countries
                       
    countryList = countryList.map((item, index) => {
      return { label : item }
    })
    
    let vendorTypes = allTypes.map((item, index) => {
      return { label : item.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        })}
    })
    this.state = {      
      currentTab : 0,
      disableNextTabButton : false,
      nextButtonText : "NEXT",
      forms : [],
      showReviewPage : false,
      showTabs : true,
      showErrorMessage : false,      
      errorMessage : "",
      priceRange : this.nigeriaPriceRanges,      
      data : {
        email : "",
        password : "",
        currency : "naira"
      },
      data_status : {
        
      },
      contactForm : {
        title : "Contact Information",
        score : 1250,
        form : [
        {
          name: "name",
          label: "Business Name",
          type: "text",        
        },
        {
          name : "phone",
          label : "Phone Number (Include country code)",
          type : "tel"
        },
        {
          name: "email",
          label: "Email",
          type: "email",
        },
        {
          name: "password",
          label: "Password",
          type: "password",
          // grid_css: "no-gutters",
          // field_grid_size: "12",
          // input_css : "mb-5"
        }
      ]},
      locationForm : {
        title : "Location Information",
        score : 1250,
        form : [
          {
            name: 'country',
            label: 'Country',
            type : "text",
            meta : {
              autocomplete : true,
              options : countryList
            }
          },
          {
            name: 'state',
            label: 'State/Province',        
            type : "text"
          },
          {
            name: 'city',
            label: 'City',        
            type : "text"
          },
          {
            name: 'street',
            label: 'Address (Street No. and Name)',  
            type : "text"      
          },
          {
            name: 'postalcode',
            label: 'Postal/Zip Code',        
            type : "text"
          },
        ]
      },
      socialMediaForm : {
        title : "Social Media Information",
        score : 1250,
        form : [
          {
            name: "instagram",
            label: "Instagram",
            type: "text",
          },
          {
            name : "facebook",
            label : "Facebook",
            type : "text"
          },
          {
            name: "twitter",
            label: "Twitter",
            type: "text",
          },
        ]
      },
      serviceInfoForm : {
        title : "Service Information",
        score : 1250,
        form : [
          {
            name : "services",
            label : "Main Service",
            type : "text",
            meta : {
              autocomplete : true,
              options : vendorTypes
            }
          },         
          {
            name : "prices",
            label : "Price Range (naira)",
            type : "select",
            default : "",
            meta : {
              options : this.nigeriaPriceRanges,
              multiple : true
            }
          }
        ]
      }
    }
      

  }

  componentDidMount(){    
    this.setState({
      currentTab : 0,
      disableNextTabButton : false,
      nextButtonText : "NEXT",
      forms : [this.state.contactForm, this.state.locationForm, this.state.socialMediaForm, this.state.serviceInfoForm],
      showReviewPage : false,
      showTabs : true,
      priceRange : this.nigeriaPriceRanges,
      data : {
        email : "",
        password : "",
        currency : "naira"
      },
      optionalFields: ["postalcode", "facebook", "twitter"]
    })
  }

  saveToState = (data, isValid) => {
    const { name, value } = data
    const newData = Object.assign(this.state.data, {[name]: value})  

    if(name === "country"){
      
      if(value.toLowerCase() === "nigeria" && this.state.priceRange!==this.nigeriaPriceRanges){        
        let newServiceForm = Object.assign(this.state.serviceInfoForm, {})    

        newServiceForm.form[1].label="Price Range (naira)"
        newServiceForm.form[1].meta = {
          options : this.nigeriaPriceRanges,
          multiple : true
        }

        this.setState({ 
          serviceInfoForm : newServiceForm,
          priceRange : this.nigeriaPriceRanges,
        })

      }
      else{        
        let newServiceForm = Object.assign(this.state.serviceInfoForm, {}) 
        
        newServiceForm.form[1].label="Price Range (dollars)"

        newServiceForm.form[1].meta = {
          options : this.usPriceRanges,
          multiple : true
        }  
        this.setState({ 
          serviceInfoForm : newServiceForm,
          priceRange : this.usPriceRanges,
        })

      }
    }
    
    this.setState({ 
      data : newData,
      data_status : Object.assign(this.state.data_status, {[name] : isValid})
    });

  }

  formIsValid = (form) => {    
    for(let field in form){
      const currentField = form[field]
      if((this.state.optionalFields.indexOf(currentField.name) > -1)
        || this.state.data_status[currentField.name]){
        continue
      }
      else{
        this.setState({
          errorMessage : `${currentField.label} : ${ErrorMessages(currentField.type, this.state.data[currentField.name] || "" )}`
        })
        return false
      }
    }

    return true
  }


  nextTab = () => {
    // if(true){
    if(this.formIsValid(this.state.forms[this.state.currentTab].form)){
        this.setState({
          showErrorMessage : false,
          errorMessage : ""
        })

        if(this.state.currentTab === (this.state.forms.length - 1)){
          this.setState({ 
            showReviewPage : true,
            showTabs : false
          })
        } 

        if(this.state.currentTab !== (this.state.forms.length - 1)){
          this.setState({      
            currentTab : this.state.currentTab + 1
          }, () => {
            // Check if this is the last tab
            if(this.state.currentTab === (this.state.forms.length - 1)){
              this.setState({ nextButtonText : "FINISH" })
            }        
          })
        }
    }
    else{
      this.setState({
        showErrorMessage : true
      })
    }
  }


  previousTab = () => {
    if(this.state.currentTab !== 0){
      const currentTab = this.state.currentTab === 3 ? this.state.currentTab : this.state.currentTab - 1
      this.setState({      
        currentTab : currentTab,
        nextButtonText : "NEXT",
        showReviewPage : false,
        showTabs : true
      })
    }        
  }

  renderProgressBars = () => {    
    return this.state.forms.map((item, index) => {
      return <div 
              className={"lush-bar col-xs-12 mt-3 " + ((index <= this.state.currentTab) ? "filled-bar" : "")}
              key={index}>
              </div>
    })
  }

  renderReviewPage = () => {
    let tokens = 0
    this.state.forms.map((form, id) => tokens += form.score)  
    return (
      <div hidden={!this.state.showReviewPage}>
        <h4 className="earning center">
          You have earned {tokens} lush tokens review your information and submit to redeem them.
        </h4>
        <h1 className="center">REVIEW</h1>
        {this.state.forms.map((form, id) => {            
            return  (
              <div key={id}>
                <div className="center col-xs-12">
                  <hr></hr>
                  <h3>{form.title.toUpperCase()}</h3>
                  <hr></hr>
                </div>  
                {form.form.map((item, id) => {
                  return <FormField 
                          key={id}
                          fieldChange = {this.saveToState}
                          value = {this.state.data[item.name] || item.default || ""}
                          field={item}
                          submitActive={this.state.submit} />
                })}
              </div>
            )
          })}
      </div>
      )
  }

  renderErrorMessage = () => {
    return (
      <div className="error-container" hidden={!this.state.showErrorMessage}>
        {this.state.errorMessage}
      </div>
    )
  }


  submitForm = () => {
    // let valid = null
    for(let index in this.state.forms){      
      // if(false){
      if(!this.formIsValid(this.state.forms[index].form)){
        this.setState({
          showErrorMessage : true
        })
        return
      }
    }
    let d = JSON.parse(JSON.stringify(this.state.data));
    let profile = JSON.parse(JSON.stringify(this.state.data));
    profile.sslt = 5000 + "" //Give 5000 for all signups
    d.profile = profile
    d.react = true

    fetch(api + "auth/register", {
      method: 'POST',
      headers: new Headers({
                 'Accept': 'application/json',
                 'Content-Type': 'application/json',
        }),
      body: JSON.stringify(d)
    })
    .then((response) => response.json())
    .then((res) => {
      if (res.message) {
        swal("IMPORTANT!", res.message, "info");
      } else {
        swal("Great work!", "You have submitted your vendor profile. Check your email to finish!", "success");
      }
    })
    .catch((err) => {
      swal("Something went wrong!", String(err), "error");
    });
  }


  render() {
    return (
      <div className="height">
      <hr className="spacer"></hr>
        <div id="tab-container" className="mx-auto"> 
          <div className="row mx-auto col-xs-12 progressSection">            
            {this.renderProgressBars()}            
          </div>

          {this.state.forms.map((form, id) => {
            let pageScores = [0]
            let totalPageScore = 0
            this.state.forms.map((form, id) => {
              pageScores.push(form.score + pageScores[id])
              totalPageScore += form.score
              return null;
            })                  
            return <Tab
                      index={id}
                      pageScore={pageScores[id]}
                      totalPageScore={totalPageScore}                      
                      key={id}     
                      title={form.title}       
                      tabForm={form.form} 
                      hidden={id!==this.state.currentTab || !this.state.showTabs}
                      onInput={this.saveToState}
                    />
          })}

          {this.renderReviewPage()}

          {this.renderErrorMessage()}

          <div className="center" hidden={!this.state.showTabs}>
            <button onClick={this.previousTab} className="mt-4 lush-btn"  key={'backBtn'}>           
              <b> BACK </b>
            </button>

            <button onClick={this.nextTab} className="mt-4 ml-1 lush-btn"  key={'nextBtn'}>           
              <b> {this.state.nextButtonText} </b>
            </button>      
          </div>

          <div className="center" hidden={!this.state.showReviewPage}>
            <button onClick={this.previousTab} className="mt-4 lush-btn">
              BACK
            </button>
            <button onClick={this.submitForm} className="mt-4 ml-1 lush-btn">           
              <b> SUBMIT </b>
            </button>
          </div>          
        </div> 
        <br></br>  
        <br></br>    

      </div>
      )
  }
};


class Tab extends Component {
  constructor(props){
    super(props)    
    this.state = {
      form : [],
      data : {}
    }
  }

  componentDidMount(){
    this.setState({
      form : this.props.tabForm || []
    })    
  }

  componentWillReceiveProps(nextProps){   
    this.setState({
      form : nextProps.tabForm || []
    })
  }

  saveToState = (data, isValid) => {
    const { name, value } = data

    const newData = Object.assign(this.state.data, {[name]: value})
    
    this.setState({ data : newData });
    
    this.props.onInput(data, isValid)
  }

  render(){
    return (
      <div hidden={this.props.hidden}>
        <div className="center">
          <h4 className="earning">
            You can earn {(this.props.totalPageScore - this.props.pageScore) + " "} Lush Tokens. 
            You have {this.props.pageScore + " "}
          </h4>
          <h6>{this.props.title.toUpperCase()}</h6>
        </div>        
        <hr />
        {this.state.form.map((item, id) => (
            <FormField 
              key={id}
              fieldChange = {this.saveToState}
              value = {this.state.data[item.name] || item.default || ""}
              field={item}/>
          ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Signup/Signup.js